import { css } from '@emotion/css';
import { N0, N100, N700, primary } from '@assets/colors';

export const styContainer = css`
  display: flex;
  justify-content: center;
`;

export const styBoxContainer = (withBackground, textAlign = 'center') => css`
  min-width: 550px;
  max-width: 550px;
  background: ${withBackground ? N0 : 'none'};
  padding: 24px;
  box-shadow: ${withBackground ? '0px 2px 8px -2px rgba(96, 122, 141, 0.15)' : 'none'};
  border-radius: 16px;
  text-align: ${textAlign};
`;

export const styProfile = css`
  border: 1px solid ${N100};
  border-radius: 40px;
  padding: 8px;
  display: inline-block;
  margin-top: 16px;
  margin-bottom: 54px;
  & > div {
    display: flex;
    align-items: center;
  }
  & span {
    margin-left: 8px;
  }
`;

export const styButton = css`
  color: ${N700};
  font-size: 16px;
  &:hover {
    color: ${primary};
  }
`;

export const styProfilePicture = css`
  border-radius: 50%;
`;
